import React from "react";
import PendingProducts from "./pendingProducts";
import DashboardCounts from "./DashboardCounts";
import ProductComments from "./product-comment";
import "./style.scss";
import PendingTickets from "./pendingTickets";
import PendingContact from "./pendingContacts";
import DashboardPendingContracts from "./pendingContracts";

function Dashboard() {
  return (
    <React.Fragment>
      <div className={"content-flex1"} style={{ marginBlockStart: 30 }}>
        <div className={"dashboard-grid-outer-div"}>
          <DashboardCounts></DashboardCounts>
        </div>
        <div className={"dashboard-grid-outer-div"}>
          <PendingTickets></PendingTickets>
        </div>
        <div className={"dashboard-grid-outer-div"}>
          <PendingContact></PendingContact>
        </div>
        <div className={"dashboard-grid-outer-div"}>
          <PendingProducts></PendingProducts>
        </div>
        <div className={"dashboard-grid-outer-div"}>
          <ProductComments></ProductComments>
        </div>

        <div className={"dashboard-grid-outer-div"}>
          <DashboardPendingContracts></DashboardPendingContracts>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Dashboard;
